<template>
	<div class="PL-container">
		<div class="productList-wrap swiper-container">
         <div class="swiper-wrapper">
            <div class="swiper-slide" v-if="children[0]">
				 	<div class="product-item">
				 	 	<h6>KIDS</h6>
				 	 	<div class="img" @click="goto(1)">
				 	 		<img :src="children[0].thumb">
				 	 	</div>
				 	 	<div class="product-size-descrition">
				 	 		 <strong>SIZE :</strong> <span>{{children[0].remark}}</span> 
				 	 	</div>
				 	 	<div class="product-size-descrition">
				 	 		 <button type="button" @click="goto(1)">Learn More</button>
				 	 	</div>
				 	</div>
				</div>
				<div class="swiper-slide" v-if="adult[0]"> 
				 	<div class="product-item">
				 	 	<h6>ADULTS</h6>
				 	 	<div class="img" @click="goto(2)">
				 	 		<img :src="adult[0].thumb">
				 	 	</div>
				 	 	<div class="product-size-descrition">
				 	 		 <strong>SIZE :</strong>  <span>{{adult[0].remark}}</span> 
				 	 	</div>
				 	 	<div class="product-size-descrition">
				 	 		 <button type="button" @click="goto(2)"> Learn More</button>
				 	 	</div>
				 	</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
   import Swiper from 'swiper';
   import {mapState} from 'vuex';
	export default {
		name: "productList",
		data() {
			return {
               goodsList:[],
               adult:[],
               children:[],
               gt:[],
			}
		},
		computed: {
			...mapState({
            web: state => state.web,
         }),
		},
		mounted() {
           this.getProduct();
		},
		methods: {
            goto(id){

               this.$router.push("/productType/"+id)
            },
            getProduct(){
				
				 var app= this;
				 
				 this.$api("/index/getGoodsList",{},"POST").then(function(res){

				     if(res.status=="200"){

                  app.goodsList =  res.data;
						app.adult =  res.data.adult;
						app.children =  res.data.children;
						app.gt =  res.data.GT;

						// if(app.web){
						// 	app.$nextTick(function() {		
						// 		new Swiper('.productList-wrap', {
						// 			autoplay: false,
						// 		})				
						// 	})
						// }

				

				     }
				 
				 })
			},
		}

	}
</script>

<style lang="less" >


	.PL-container { 
		min-height: calc(100vh - 96px);
		display: flex;
		justify-content: center;
		align-items: center;
		padding-top: 96px;
		.swiper-slide{
	    	width:32%;
	    	margin:0 2.5%;
	    }
		.productList-wrap {
			width: 90%;
			display:flex;
			flex-wrap:wrap;
			max-width:1920px;
			margin: 0 auto;
			.swiper-wrapper{
				justify-content:center;
			}
			.product-item{
                h6{
					font-size:24px;
					font-weight:bold;
					text-align:center;
					margin-bottom:8%;
				}
				.product-size-descrition{
					font-size:16px;
					color:#333;
					text-align:center;
					margin:20px 0;
					button{
						background-color:#000000;
						width:150px;
						color: #fff;
						font-weight: normal;
						font-size: 16px;
						line-height: 50px;
						&:hover{
							background-color:#90c31f ;
							
						}
					}
					
				}
				.img{
					width:100%;
					cursor:pointer;
					padding-top: 100%;
					background-color: #f6f6f6;
					position: relative;
					img{
						position: absolute;
						left: 50%;
						top: 50%;
						transform: translate(-50%,-50%);
						width:80%;
					}
				}
			}

		}
	}

	@media screen and (max-width:768px) {
		.PL-container{
			padding-top:50px;
			.productList-wrap{
				display:block;
				width:94%;
				.swiper-wrapper{
				   display:block;
				   .swiper-slide{
				   	width:100%;
						margin:0;
					}
				}
				.product-item{
					h6{
						margin-top:20px;
						font-size:20px;
					}
					.product-size-descrition{
						 font-size:12px;
						 button{
							line-height:40px;
							font-size:14px;
							width:100px;
						}
					}
				}
				
			}
		}
		
	}

</style>


// WEBPACK FOOTER //
// src/pages/product/productList.vue